import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const SeoComponent = props => {
  const { gtmId } = props
  useEffect(() => {
    if (!gtmId) return
    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<iframe src='https://www.googletagmanager.com/ns.html?id=${gtmId}' height='0' width='0' style='display:none;visibility:hidden'></iframe>`
    document.body.insertBefore(noscript, document.body.firstChild)
    return () => {
      document.body.removeChild(noscript)
    }
  }, [gtmId])
  return (
    gtmId && (
      <>
        <Helmet>
          <script>
            {`
            (function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
            `}
          </script>
        </Helmet>
      </>
    )
  )
}

SeoComponent.propTypes = {
  gtmId: PropTypes.string,
}

export default SeoComponent
